import { render, staticRenderFns } from "./AppColoredNotes.vue?vue&type=template&id=df5803bc&scoped=true&"
import script from "./AppColoredNotes.vue?vue&type=script&lang=js&"
export * from "./AppColoredNotes.vue?vue&type=script&lang=js&"
import style0 from "./AppColoredNotes.vue?vue&type=style&index=0&id=df5803bc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5803bc",
  null
  
)

export default component.exports